import Vue from 'vue'


const LOGO_SET_LOGOS =(state, payload)=> {  
    
    //state.logos=payload.forEach(function(x) {x.path = process.env.VUE_APP_API_PATH + 'storage' + x.serverpath})
    payload.forEach(function(x) {
            x.path = process.env.VUE_APP_API_PATH + 'storage' + x.serverpath
            x.highlight=0
            x.default=0
    })
    state.logos=payload
    //console.log(state.logos)
};

const LOGO_SET_LOGO =(state, payload)=> {  
    
    state.data.id=payload.id
    state.data.name=payload.name
    state.data.original_name=payload.original_name
    state.data.serverpath=payload.serverpath
    state.data.path=process.env.VUE_APP_API_PATH + 'storage/' + payload.serverpath
    state.data.entity_id=payload.entity_id
    state.data.highlight=0
    state.data.default=0
    
};


export default {
  LOGO_SET_LOGOS,
  LOGO_SET_LOGO
};